import { useNavigate, useParams } from "react-router-dom";
import { SessionController } from "@/components/skills/session/SessionController";

/**
 * Route page for `/skills/:slug/session`. Thin wrapper — all flow
 * lives in `SessionController`. Keeps the route file simple for the
 * router config and provides a stable navigation target for the
 * Detail page's "Start" button to redirect to after kicking off the
 * scenario state machine.
 */
export function SkillsSessionPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  if (!slug) {
    navigate("/skills", { replace: true });
    return null;
  }
  return (
    <SessionController
      slug={slug}
      onExit={() => navigate(`/skills/${slug}`)}
      // Phase 6: jump straight into the checkpoint flow. The
      // CheckpointController shows the question pool, scoring +
      // result screens, and then routes back per outcome.
      onTakeCheckpoint={() => navigate(`/skills/${slug}/checkpoint`)}
    />
  );
}
